
//= =====================
// General Actions
//= =====================
export const LOADING = 'loading',
LOADED ='loaded'

//= =====================
// Auth Actions
//= =====================
export const AUTH_USER = 'auth_user',
  AUTH_USER_EXIST = 'auth_user_exist',
  AUTH_RESET_MESSAGE = 'auth_reset_message',
  LOGOUT_USER = 'logout_user',
  DELETE_ACCOUNT = 'delete_account',
  FORGOT_PASSWORD_ACCOUNT = 'forgot_password_account',
  RESET_PASSWORD_ACCOUNT = 'reset_password_account',
  UNAUTH_USER = 'unauth_user',
  AUTH_ERROR = 'auth_error';

//= =====================
// User Profile Actions
//= =====================
export const FETCH_PROFILE = 'fetch_profile';

//= =====================
// Users Actions
//= =====================
export const FETCH_USERS = 'fetch_users',
  FETCH_USER = 'fetch_user',
  FETCH_USER_LIST = 'fetch_user_list',
  UPDATE_USER = 'update_user',
  DELETE_USER = 'delete_user',
  CREATE_USER = 'create_user',
  USER_ERROR = 'user_error',
  USER_RESET = 'user_reset',
  EXPORT_USERS_LIST = 'export_users_list';

//= =====================
// Consultant Actions
//= =====================
export const FETCH_CONSULTANTS = 'fetch_consultants',
  FETCH_CONSULTANTS_INFOS = 'fetch_consultants_infos',
  SET_STAR_IS_LOADING = 'set_start_is_loading',
  FETCH_CONSULTANT = 'fetch_consultant',
  FETCH_CONSULTANT_LIST = 'fetch_consultant_list',
  FETCH_CONSULTANT_TEAM = 'fetch_consultant_team',
  UPDATE_CONSULTANT = 'update_consultant',
  UPDATE_CONSULTANT_PICTURE = 'update_consultant_picture',
  DELETE_CONSULTANT = 'delete_consultant',
  CREATE_CONSULTANT = 'create_consultant',
  DOWNLOAD_CONSULTANT_FIELD_IMAGE = 'download_consultant_field_image',
  SET_INITIAL_STATE_CONSULTANT = 'set_initial_state_consultant',
  EXPORT_CONSULTANTS_LIST = 'export_consultants_list',
  EXPORT_CONSULTANT = 'export_consultant',
  CONSULTANT_ERROR = 'consultant_error';

//= =====================
// Projects Actions
//= =====================
export const FETCH_PROJECTS = 'fetch_projects',
  FETCH_PROJECT = 'fetch_project',
  FETCH_PROJECT_LIST = 'fetch_project_list',
  UPDATE_PROJECT = 'update_project',
  DELETE_PROJECT = 'delete_project',
  CREATE_PROJECT = 'create_project',
  SET_INITIAL_STATE_PROJECT = 'set_initial_state_project',
  PROJECT_ERROR = 'project_error',
  UPDATE_PROJECT_PICTURE = 'update_project_picture',
  EXPORT_PROJECTS_LIST = 'export_projects_list';



//= =====================
// DASHBOARD Actions
//= =====================

export const FETCH_OPERATIONALSKILLSTREE = 'fetch_operationalSkillsTree',
  FETCH_DASHBOARD = 'fetch_dashboard',
  FETCH_TECHNICALSKILLSTREE = 'fetch_technicalSkillsTree',
  FETCH_DASHBOARD_LIST = 'fetch_dashboard_list',
  DASHBOARD_ERROR = 'dashboard_error';


//= =====================
// Programs Actions
//= =====================
export const FETCH_PROGRAMS = 'fetch_programs',
  FETCH_PROGRAM = 'fetch_program',
  FETCH_PROGRAMS_LIST = 'fetch_program_list',
  UPDATE_PROGRAM = 'update_program',
  DELETE_PROGRAM = 'delete_program',
  CREATE_PROGRAM = 'create_program',
  SET_INITIAL_STATE_PROGRAM = 'set_initial_state_program',
  UPDATE_PROGRAM_PICTURE = 'update_program_picture',
  PROGRAM_ERROR = 'program_error';


//= =====================
// Rexs Actions
//= =====================
export const FETCH_REXS = 'fetch_rexs',
  FETCH_REX = 'fetch_rex',
  FETCH_REXS_LIST = 'fetch_rex_list',
  UPDATE_REX = 'update_rex',
  EXPORT_REX = 'export_rex',
  DELETE_REX = 'delete_rex',
  CREATE_REX = 'create_rex',
  SET_INITIAL_STATE_REX = 'set_initial_state_rex',
  UPDATE_REX_PICTURE = 'update_rex_picture',
  REX_ERROR = 'rex_error';

//= =====================
// Rexs Actions
//= =====================
export const FETCH_EIGHTDS = 'fetch_eightds',
  FETCH_EIGHTD = 'fetch_eightd',
  FETCH_EIGHTDS_LIST = 'fetch_eightd_list',
  UPDATE_EIGHTD = 'update_eightd',
  EXPORT_EIGHTD = 'export_eightd',
  DELETE_EIGHTD = 'delete_eightd',
  CREATE_EIGHTD = 'create_eightd',
  SET_INITIAL_STATE_EIGHTD = 'set_initial_state_eightd',
  UPDATE_EIGHTD_PICTURE = 'update_eightd_picture',
  EIGHTD_ERROR = 'eightd_error';



//= =====================
// Quaterly Report Actions
//= =====================
export const FETCH_QUATERLY_REPORT = 'fetch_quaterly_report',
              QUATERLY_REPORT_ERROR = 'quaterly_report_error',
              FETCH_QUATERLY_REPORT_LIST = 'fetch_quaterly_report_list',
              CREATE_QUATERLY_REPORT = 'create_quaterly_report',
              UPDATE_QUATERLY_REPORT = 'update_quaterly_report',
              DELETE_QUATERLY_REPORT = 'delete_quaterly_report',
              SET_INITIAL_STATE_QUATERLY_REPORT = 'set_initial_state_quaterly_report',
              OLD_QUATERLY_REPORT_ERROR = 'old_quaterly_report_error',
              UPDATE_QUATERLY_PICTURE = 'update_quaterly_picture',
              EXPORT_QUATERLY_REPORT = 'export_quaterly_report',
              EXPORT_OLD_QUATERLY_REPORT = 'export_old_quaterly_report';


//= =====================
// Chatbot Actions
//= =====================
export const CHATBOT_ERROR = 'chatbot_error',
    ASK_CHATBOT = 'ask_chatbot',
    CHATBOT_RESET = 'reset_chatbot';